// Clean-URL helpers for article links.
//
// Articles live in JSON files under /public/data (e.g. "/data/featured.json" or
// "/data/blogs/recipes.json") and each item has a numeric `id`. We expose them at
// human/crawler-friendly paths:
//
//   /data/featured.json      + id 1  ->  /learn/article/featured/1
//   /data/blogs/recipes.json + id 5  ->  /learn/article/blogs/recipes/5
//
// The "slug" is the JSON path relative to /data with the .json extension dropped,
// so it can contain a "/" (the blogs subfolder). Routing therefore uses a splat
// route and these helpers reconstruct the original JSON path on the article page.
// The build-time prerenderer (client/scripts/prerender-articles.js) mirrors this
// same mapping so the generated static pages live at the exact same paths.

// "/data/blogs/recipes.json" -> "blogs/recipes"
export const topicFileToSlug = (topicFile) =>
  String(topicFile || "")
    .replace(/^\/?data\//, "")
    .replace(/\.json$/i, "");

// "blogs/recipes" -> "/data/blogs/recipes.json"
export const slugToTopicFile = (slug) =>
  `/data/${String(slug || "").replace(/^\/+|\/+$/g, "")}.json`;

// Build the clean article path: /learn/article/<slug>/<id>
export const buildArticlePath = (topicFile, articleId) =>
  `/learn/article/${topicFileToSlug(topicFile)}/${articleId}`;

// Parse the router splat ("blogs/recipes/5") -> { topicFile, articleId }.
// Returns null when the splat isn't a valid <slug>/<id> shape.
export const parseArticleSplat = (splat) => {
  const parts = String(splat || "")
    .split("/")
    .filter(Boolean);
  if (parts.length < 2) return null;
  const articleId = parseInt(parts[parts.length - 1], 10);
  if (Number.isNaN(articleId)) return null;
  const slug = parts.slice(0, -1).join("/");
  return { topicFile: slugToTopicFile(slug), articleId };
};
